// extracted by extract-css-chunks-webpack-plugin
module.exports = {"item":"item_2ahnW","logout":"logout_GtT-s"};